import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardFooter, CardHeader, Col, Input, Label, Row } from 'reactstrap';
import OSelect from '../../../../Components/OElements/OSelect';
import PageComponents from './Graph/PageComponents';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getGraph, getGraphList, updatePage } from '../../../../slices/thunks';
import { LoadLogoLogin } from '../../../../Layouts/LoadLogo';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';

const TitleGraphPage = ({ page, report }) => {
    const { logoSrc, isSettingsLoading } = useLogoLoader("login");

    const dispatch = useDispatch();

    const [inputName, setInputName] = useState(page.name);
    const [inputText, setInputText] = useState(page.elements[0].text);
    const [graph, setGraph] = useState(page.elements[0].graph);
    const [graphCode, setGraphCode] = useState(null);
    const [table, setTable] = useState(null);


    const { itemGraphDetail, isGraphLoading } = useSelector(state => ({
        itemGraphDetail: state.Screen.itemGraphDetail,
        isGraphLoading: state.Screen.isGraphLoading
    }));


    useEffect(() => {
        dispatch(getGraph(graph))
    }, [graph]);


    const SelectedGraphComponent = PageComponents[graphCode]
    useEffect(() => {
        if (itemGraphDetail) {
            setGraphCode(itemGraphDetail.code)
        }
    }, [itemGraphDetail]);


    useEffect(() => {
        const handler = setTimeout(() => {
            if (inputName !== page.name) {
                updateTitlePage(page, inputName);
            }
        }, 2000);

        return () => {
            clearTimeout(handler);
        };
    }, [inputName]);


    useEffect(() => {
        const handler = setTimeout(() => {
            const updateText = async () => {
                if (inputText !== page.elements[0].text) {
                    const updatedPage = await updateElement(page, 'text', inputText);
                    dispatch(updatePage(updatedPage));
                }
            };

            // Llamamos a la función asincrónica
            updateText();
        }, 2000);

        return () => {
            clearTimeout(handler);
        };
    }, [inputText]);




    const updateElement = async (page, field, value) => {
        // Si page.elements es null o undefined, lo inicializamos como un array vacío
        const elements = page.elements ?? [];
        // Encontrar el índice del elemento que tiene el campo 'field' igual a 'value'
        const elementIndex = elements.findIndex(el => el.hasOwnProperty(field));

        // Si el elemento ya existe, lo actualizamos
        if (elementIndex !== -1) {
            return {
                ...page,
                elements: elements.map((el, elIndex) => {
                    if (elIndex === elementIndex) {
                        return {
                            ...el,
                            [field]: value, // Aquí puedes actualizar el valor si es necesario
                        };
                    }
                    return el;
                }),
            };
        } else {
            // Si no existe, lo agregamos como un nuevo elemento
            return {
                ...page,
                elements: [...elements, { [field]: value }],
            };
        }
    };

    const updateTitlePage = (page, title) => {
        // Actualizar el título de la página
        const updatedPage = {
            ...page,  // Hacemos una copia del objeto para mantener inmutabilidad
            name: title
        };
        // Disparamos la acción de actualización con el nuevo objeto de la página
        dispatch(updatePage(updatedPage));
    };




    return (
        <Card className='border card-border-primary'>
            <CardHeader className='text-end'>

                <Row>
                    <Col>
                        <div className="d-flex justify-content-start">
                            <LoadLogoLogin
                                logoSrc={logoSrc}
                                isSettingsLoading={isSettingsLoading}
                                maxHeight={30}
                                maxWidth={'300px'}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Input
                            name='title'
                            id='title'
                            className='form-control w-100'
                            placeholder='Ingrese un título de la portada'
                            type='text'
                            value={inputName}
                            onChange={(e) => setInputName(e.target.value)}
                            style={{ textAlign: 'right' }}
                        />
                    </Col>
                </Row>



            </CardHeader>
            <CardBody>
                <Col md={12}>
                    <div style={{ height: '300px' }}>
                        {SelectedGraphComponent ? (
                            <div style={{ height: '300px' }}>
                                <React.Suspense fallback={<div>Cargando...</div>}>
                                    <SelectedGraphComponent
                                        report={report}
                                        page_id={page}
                                    />
                                </React.Suspense>
                            </div>
                        ) : <OPlaceholder />}
                    </div>
                </Col>
            </CardBody>
            <CardFooter className="bg-primary text-white">
                <Row className="g-0">
                    <Col md={12} className='p-2'>
                        <Label for="text" className="form-label">
                            Texto
                        </Label>
                        <Input
                            name="text"
                            id="text"
                            className="form-control"
                            placeholder="Ingrese un texto"
                            type="textarea"
                            value={inputText}
                            rows={3}
                            onChange={(e) => setInputText(e.target.value)}
                        />
                    </Col>
                </Row>
            </CardFooter>
        </Card>
    );
};

export default TitleGraphPage;
